import { render, staticRenderFns } from "./finished-movements-table.vue?vue&type=template&id=6b38a320"
import script from "./finished-movements-table.vue?vue&type=script&lang=js"
export * from "./finished-movements-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports